import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ChevronLeft';

import ContextMenu from './ContextMenu';
export default function ContextMenuItem(props){
  let {item,onClose,onEvent, treeLevel, openPath=[], setOpenPath, submenuDirection="right", globalStyle,
    roundCorners,
  } = props;

  const submenuProps = {...props,...item, globalStyle, roundCorners};

  let { style={}, title, action, type, submenu, ignore, hoverable } = item;

    // --- Non-interactive separator line ---
  if (type === 'separator' || action === 'line') {
    return (
      <tr aria-hidden="true">
        {/* there are always three cells in a row: [optional arrow] [content] [optional arrow] */}
        <td colSpan={3} style={{ padding: 0 }}>
          <div
            style={{
              margin: '6px 8px',
              height: 1,
              background: '#d0d0d0',
              pointerEvents: 'none',
            }}
          />
        </td>
      </tr>
    );
  }

  /*
  const submenuArgs = {
    submenuDirection="right", submenu, openPath,setOpenPath,treeLevel,action,onEvent,onClose
  }*/

  let content = (
    <td class="">
      <div 
        contextmenuitem={action}
        onMouseDown={(e) => {
          e.stopPropagation();
          e.preventDefault();
          e.canDrag = false;
        }}
        onClick={e => {

        }}
        style={{
          pointerEvents:'auto',
          lineHeight: 1,
          fontSize:12,
          borderRadius:0,
          textAlign:'left',
          whiteSpace:'nowrap',
          ...globalStyle,
          ...style,
        }} class={"inherit-hover toolbar-action-button toolbar-button "+(hoverable && "hoverable")}>
        {title}
      </div>
    </td>
  )

  return (

    <tr 
      path={openPath.join('^-^')}
      onMouseDown={e => {
        e.stopPropagation();
        e.preventDefault();
      }}

      onClick={(e) => {

        e.stopPropagation();
        e.preventDefault();

        if( ignore ){
          return;
        }

        console.log("Context item clicked...");

        onEvent({
          event:e,
          ...item
        });

        onClose && onClose();


      }}

      onMouseLeave={e => {

        e.stopPropagation();
        //setOpenPath(openPath.slice(-1))
        console.log("MOUSE LEAVE")
        console.log(e.target.getAttribute("path"));
        let path = Array.from(
          e.nativeEvent.composedPath()
        )
        //debugger;
        console.log(e);
        console.log(item);
        console.log("--------");
      }}

      onMouseEnter={() => {

      setOpenPath(
        [...openPath.slice(0,treeLevel), action ]
      )


    }} 
      class="rel"
      //class={"new-hoverable " + (hoverable !== false && "hoverable")} 
    style={{
      alignItems:'center',
      //border:'1px solid lime',
    }}>
      
    
      {submenuDirection==="left" && (
        submenu ? <SubmenuExpansion {...{...submenuProps}}/> : (
          <td style={{width:40}}/>
        ))}


      {content}
      
      {submenuDirection==="right" && (
        submenu ? <SubmenuExpansion {...{...submenuProps}}/> : (
          <td style={{width:40}}/>
        ))}

    </tr>
  )

}

function SubmenuExpansion({submenuDirection="right", submenu, openPath,setOpenPath,treeLevel,action,onEvent,onClose, style, globalStyle, roundCorners }){
  
  if(!submenu){
    return null;
  }

  const iconStyle = {
    

    //outline:'3px solid lime',
    
    textAlign:'center',
    pointerEvents:'none',

    //...globalStyle,
    //...style,

    fontSize:24,
    //background:'white',
    //background:'transparent',
    //padding:0,
    //marginLeft:-10
  }


  const directionSpecficInfo = {
    right:{
      arrow:(<ArrowForwardIosIcon style={iconStyle}/>)
    },
    left:{
      arrow:(<ArrowBackIosIcon style={iconStyle}/>),
      transform:"translate(-100%,0)"
    }
  }

  let left = submenuDirection === "left";
  let right = !left;

  let { arrow, transform } = directionSpecficInfo[submenuDirection];


  return (
    <td class="inherit-hover" style={{
      position:'relative',
      minWidth:20,
      width:40,
      ...globalStyle,
      ...style,
      //background:'red',
    }}>
      <div style={{
        //zIndex:10,
        //border:'3px solid red',
        //paddingLeft:4,

        //background:'orange',

        position:'absolute', 
        top:0, 
        [submenuDirection]:0,
        //left:0 ,
        textAlign:'center',
        //transform:'translate(25%)',
        //pointerEvents:'none',
      }} class="full-height full-width sg-row h-center v-center inherit-hover">
        {arrow}
      </div>


      {openPath[treeLevel] === action && (
        <div style={{position:'absolute',
          top:-3,
          [submenuDirection]:0,
          background:'white'
          }}>

          <ContextMenu roundCorners={roundCorners} globalStyle={globalStyle} submenuDirection={submenuDirection} openPath={openPath} treeLevel={treeLevel+1} setOpenPath={setOpenPath} onClose={onClose} onEvent={onEvent} items={submenu} transform={transform}/>

        </div>
      )}

    </td>
  )

}

// {openPath[treeLevel] === action &&

